module.exports = __webpack_public_path__ + "4a7071ea556bacee243fa55bb31a4573.svg";